export function initVideoBoxes() {
    const videoWrappers = document.querySelectorAll(".video-box__wrapper");

    if (!videoWrappers.length) return;

    // --- 1️⃣ Розблокування медіа для всіх відео після першої взаємодії
    let mediaUnlocked = false;
    function unlockMediaPlayback() {
        if (mediaUnlocked) return;
        mediaUnlocked = true;

        const vids = document.querySelectorAll('video');
        vids.forEach(v => {
            v.muted = true;
            v.play().then(() => {
                v.pause();
                v.currentTime = 0;
            }).catch(() => {});
        });
    }

    window.addEventListener('mousedown', unlockMediaPlayback, { once: true });
    window.addEventListener('touchstart', unlockMediaPlayback, { once: true });

    // --- 2️⃣ Ініціалізація кожного відео-блоку
    videoWrappers.forEach(wrapper => {
        const overlay = wrapper.querySelector(".video-overlay");
        const playButton = overlay?.querySelector(".video-play-btn");
        const video = wrapper.querySelector(".video-box__video");
        const sources = video?.querySelectorAll("source");

        if (!video) return;

        // --- Lazy load відео
        const observer = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    sources?.forEach(src => {
                        if (src.dataset.src) src.src = src.dataset.src;
                    });
                    video.load();
                    obs.unobserve(video);
                }
            });
        }, { rootMargin: "200px 0px" });
        observer.observe(video);

        // --- Обробник кліку на кнопку Play
        if (playButton) {
            playButton.addEventListener("click", async () => {
                overlay.classList.add("hidden");
                video.setAttribute("controls", "controls");

                try {
                    // спроба програти зі звуком
                    video.muted = false;
                    await video.play();
                } catch (err) {
                    console.warn("Autoplay with sound blocked — playing muted instead:", err);
                    // fallback — якщо не можна зі звуком
                    video.muted = true;
                    await video.play().catch(() => {});
                }
            });
        }

        // --- Коли відео закінчується — повертаємо overlay
        video.addEventListener("ended", () => {
            overlay?.classList.remove("hidden");
            video.removeAttribute("controls");
            video.currentTime = 0;
            video.pause();
        });
    });
}
